import VehiclesGroupedReport from "./VehiclesGroupedReport";

export default function VehiclesByDistrict() {
  return (
    <VehiclesGroupedReport
      title="Vehicles by District"
      subtitle="Active fuel access registrations grouped by the district of the user's retail outlet."
      dimension="district"
      dropdownLabel="District"
      dropdownPlaceholder="All districts"
      dropdownApiPath="/master/districts"
    />
  );
}
